/**
 * Frontend Logger Utility with Timestamps
 * Format: YYYY-MM-DD HH:MM:SS | LEVEL | message
 */

const formatTimestamp = () => {
  const now = new Date();
  const pad = (n) => n.toString().padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
};

const formatMessage = (level, ...args) => {
  const timestamp = formatTimestamp();
  const message = args.map(arg => 
    typeof arg === 'object' ? JSON.stringify(arg) : arg
  ).join(' ');
  return `${timestamp} | ${level.padEnd(8)} | ${message}`;
};

const logger = {
  info: (...args) => {
    console.log(formatMessage('INFO', ...args));
  },
  
  warn: (...args) => {
    console.warn(formatMessage('WARNING', ...args));
  },
  
  error: (...args) => {
    console.error(formatMessage('ERROR', ...args));
  },
  
  debug: (...args) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(formatMessage('DEBUG', ...args));
    }
  },
  
  // For API calls tracking
  api: (method, url, status, duration) => {
    const level = status >= 400 ? 'ERROR' : 'INFO';
    console.log(formatMessage(level, `${method} ${url} - ${status} (${duration}ms)`));
  }
};

export default logger;
